import { GERMAN_STATES, type VacationSummary } from '@kontor/shared';

const num = (n: number) => n.toLocaleString('de-DE', { maximumFractionDigits: 1 });

/** Urlaub im Jahr: Anspruch, genommen, beantragt, Rest (KON-120). Für die Mitarbeiterkarte und „Mein Konto“. */
export function VacationFacts({ vacation }: { vacation: VacationSummary }) {
  const v = vacation;
  return (
    <div className="vacation">
      <h3 className="vacation__title">Urlaub {v.year}</h3>
      {v.entitlement === null ? (
        <p className="muted small">Noch kein Urlaubsanspruch hinterlegt.{v.taken > 0 ? ` Genommen: ${num(v.taken)} Tage.` : ''}</p>
      ) : (
        <div className="vacation__tiles">
          <div className="vacation__tile"><span className="muted small">Anspruch</span><strong>{num(v.entitlement)}</strong></div>
          <div className="vacation__tile"><span className="muted small">Genommen</span><strong>{num(v.taken)}</strong></div>
          <div className="vacation__tile"><span className="muted small">Beantragt</span><strong>{num(v.requested)}</strong></div>
          <div className={`vacation__tile vacation__tile--rest${v.remaining !== null && v.remaining - v.requested < 0 ? ' is-negative' : ''}`}><span className="muted small">Rest</span><strong>{num(v.remaining ?? 0)}</strong></div>
        </div>
      )}
      <p className="muted small">Arbeitstage Montag bis Freitag ohne die Feiertage in {GERMAN_STATES[v.state]}. Beantragte Tage gehen erst mit der Genehmigung vom Rest ab.</p>
    </div>
  );
}
